/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Damages_AddInputs */

const en_case_damages_add = /** @type {(inputs: Case_Damages_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add value`)
};

const pt_br2_case_damages_add = /** @type {(inputs: Case_Damages_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adicionar valor`)
};

/**
* | output |
* | --- |
* | "Add value" |
*
* @param {Case_Damages_AddInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_damages_add = /** @type {((inputs?: Case_Damages_AddInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Damages_AddInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_damages_add(inputs)
	return pt_br2_case_damages_add(inputs)
});